module.exports = __webpack_public_path__ + "img/potencia_b_blue.f88b6914.svg";